import styled from "styled-components";

export const StyledMain = styled.main`
    background: #f9f9f8;
    margin-top: 66px;
    min-height: 99vh;
`;
